var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.isRouterAlive ? _c("router-view") : _vm._e(),
      _vm.show
        ? _c("div", { staticClass: "notice_dialog" }, [
            _c("div", { staticClass: "notice_content" }, [
              _c("div", { staticStyle: { position: "relative" } }, [
                _c("img", {
                  staticClass: "closebtn",
                  attrs: {
                    src: _vm.$common.imageRoot + "/closebtn.png",
                    alt: "",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.next_()
                    },
                  },
                }),
                _c("h1", { staticClass: "notice_title" }, [
                  _vm._v(_vm._s(_vm.content.title)),
                ]),
                _c("section", {
                  staticClass: "content",
                  domProps: { innerHTML: _vm._s(_vm.content.content) },
                }),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }